import useUrl from "hook-use-url";

export default function usePage() {
  const url = useUrl();

  const page = url.get("page") ? parseInt(url.get("page"), 10) : 0;

  const setPage = (value) => {
    url.set("page", value).replace();
  };

  return [page, setPage];
}
